import { environment } from '@/environments/environment'

export default [
  { name: 'getWhatsApp', url: 'http://localhost:8000/get_ws/v1/get_ws/{company_id}', method: 'get'},
  { name: 'activeWhatsApp', url: 'http://localhost:8000/active_ws/v1/active_ws/{company_id}', method: 'post'},
  { name: 'editWhatsApp', url: 'http://localhost:8000/edit_ws/v1/edit_ws/{company_id}', method: 'put'}
]